type InputType = "mouse" | "touch";

export interface GameState {
  id?: string;
  isOnTitle: boolean;
  roundIndex: number;
  isOnGameOver: boolean;
  inputType: InputType;
  gameStreakComplete?: boolean;
}

export const INITIAL_STATE: GameState = {
  isOnTitle: true,
  roundIndex: 0,
  isOnGameOver: false,
  inputType: "mouse",
};

export const GameAction = {
  NEW_GAME: "NEW_GAME",
  NEW_INPUT_TYPE_DETECTED: "NEW_INPUT_TYPE_DETECTED",
  TITLE_SCREEN_EXITED: "TITLE_SCREEN_EXTIED",
  ROUND_COMPLETED: "ROUND_COMPLETED",
  GAME_COMPLETED: "GAME_COMPLETED",
  GAME_STREAK_COMPLETED: "GAME_STREAK_COMPLETED",
} as const;

export type GameAction =
  | { type: typeof GameAction.NEW_GAME; payload: { gameId: string } }
  | {
      type: typeof GameAction.NEW_INPUT_TYPE_DETECTED;
      payload: { inputType: InputType };
    }
  | { type: typeof GameAction.TITLE_SCREEN_EXITED }
  | { type: typeof GameAction.ROUND_COMPLETED }
  | { type: typeof GameAction.GAME_COMPLETED }
  | {
      type: typeof GameAction.GAME_STREAK_COMPLETED;
    };

export function gameReducer(state: GameState, action: GameAction) {
  switch (action.type) {
    case GameAction.NEW_GAME:
      return {
        ...INITIAL_STATE,
        id: action.payload.gameId,
      };
    case GameAction.NEW_INPUT_TYPE_DETECTED:
      return {
        ...state,
        inputType: action.payload.inputType,
      };
    case GameAction.TITLE_SCREEN_EXITED:
      return {
        ...state,
        isOnTitle: false,
      };
    case GameAction.ROUND_COMPLETED:
      return {
        ...state,
        roundIndex: state.roundIndex + 1,
      };
    case GameAction.GAME_COMPLETED:
      return {
        ...state,
        isOnGameOver: true,
      };
    case GameAction.GAME_STREAK_COMPLETED:
      return {
        ...state,
        gameStreakComplete: true,
      };
    default:
      return state;
  }
}
